module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO7_19 (26).b08fcc7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO7_19 (26).mp4
// module id = 801
// module chunks = 1